const DOCUMENT_TYPE = {
  WIZARD_DOCUMENT: 'WizardDocument',
  LEASE_AGREEMENT: 'LeaseAgreement',
  SIGNATURE_REQUEST: 'SignatureRequest',
};

export default DOCUMENT_TYPE;
